const explorers: { [key: number]: string } = {
  42161: 'https://arbiscan.io',
  421613: 'https://goerli.arbiscan.io/',
  421611: 'https://rinkeby.arbiscan.io/',
  11155111: 'https://sepolia.etherscan.io/'
}
export const getBlockExplorer = (chainId: number): string => {
  return explorers[chainId] ?? explorers[11155111]
}

export const addressLink = (chainId: number, address: string): string => {
  const blockExplorer = getBlockExplorer(chainId)
  if (!blockExplorer) return ''
  return `${blockExplorer}/address/${address}`
}
